import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorLayoutComponent implements OnInit {

    constructor(
        private layoutService: LayoutService
    ) {
        this.layoutService.currentLayout$.next(this);
    }

    ngOnInit() {
    }

}
